import type { PersonalizeFormInputsDictionaryItem } from '@app/pdp/components/PersonalizedProduct/types';

export const inputsBuilder = (
    data?: number[],
    required?: boolean
): PersonalizeFormInputsDictionaryItem[] =>
    data?.map((item, index) => {
        const isRequired = required && index === 0;

        return {
            label: `Line ${index + 1}`,
            required: isRequired,
            requiredLabel: isRequired ? '(required)' : undefined,
            displayLength: true,
            optionalLabel: '',
            value: '',
            maxLength: item,
        };
    }) ?? [];
